import Vue from 'vue';
import Buefy from 'buefy';

import '@/assets/bulma.scss';

Vue.use(Buefy, {
  defaultIconComponent: 'font-awesome-icon',
  defaultIconPack: 'fas',
});
